var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.015,
    y1: 0.016,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#339560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e8c88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.293,
    x2: 0.7,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dee4ed"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(-1175 -483)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 1024,
    height: 1024,
    transform: "translate(1175 483)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M504.93.733c-19.448,14.674-26.365,34.693-29.054,56.478a316.074,316.074,0,0,0-2.244,38.11q-.259,152.309-.019,304.619c.015,11.869.633,23.78,1.77,35.6,2.17,22.549,8.481,43.335,29.241,58.521H347.572c.035-.465-.093-1.055.114-1.216,18.919-14.717,25.13-35.7,28.108-58a248.486,248.486,0,0,0,2.077-32.377q.239-133.827.092-267.657v-6.227q-.718-.169-1.434-.34c-2.262,5.893-4.6,11.76-6.776,17.683Q321.377,277.34,273.037,408.767c-9.816,26.683-19.762,53.321-29.324,80.094-1.679,4.7-4.075,6.025-8.792,5.955-13.166-.2-13.242.022-18.3-11.9q-49.867-117.506-99.68-235.035Q92.076,189.269,67.143,130.691c-.467-1.1-1.086-2.138-2.342-4.584-.2,2.872-.369,4.23-.369,5.587.017,70.526-.346,141.055.25,211.575.284,33.388,7.951,65.254,26,93.938,15.56,24.726,37.228,42.182,64.387,52.906q3.257,1.285,6.469,2.678c.322.139.526.547,1.286,1.378H4.418c-.095-.286-.188-.571-.282-.856,2.2-1.056,4.352-2.2,6.594-3.153,16.843-7.148,28.214-19.56,31.612-37.352A269.6,269.6,0,0,0,47.57,404.2q.969-156.447.612-312.9c-.137-35.1-16.258-63.543-42.593-86.364C4.17,3.71,2.65,2.6,0,.5,3.343.324,5.352.125,7.363.124,41.615.1,75.867.2,110.117,0c4.61-.028,6.618,1.6,8.352,5.7q47.582,112.6,95.443,225.071,26.735,63,53.423,126.026c1.051,2.478,2.175,4.923,3.264,7.384l1.435.143c2.674-6.969,5.421-13.913,8.01-20.914q48.218-130.457,96.393-260.929,14-37.919,27.969-75.85c1.172-3.179,1.867-6.093,6.681-6.079,30,.086,59.993-.2,89.988-.345a38.283,38.283,0,0,1,3.854.522",
    transform: "translate(1435 748)",
    fill: "url(#linear-gradient-2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7222570c4049071bc2fb4143d629dc9f.svg";
export { ForwardRef as ReactComponent };